import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Usamos cookies',
    description:
      'Usamos cookies y tecnologías similares para ofrecer esta experiencia. Las cookies estrictamente necesarias siempre están activas.',
    allow_label: 'Aceptar todas las cookies',
    reject_label: 'Solo las estrictamente necesarias',
    settings_label: 'Configuración de cookies',
    policy_link_label: 'Política de privacidad y cookies',
    categories_label: 'Categorías',
    always_on_label: 'Siempre activas',
    required_label: 'Obligatorias',
    save_preferences_label: 'Guardar preferencias',
    close_label: 'Cerrar',
    allow_all_optional_categories_label: 'Permitir todas las categorías opcionales',
    settings_title: 'Configuración de cookies',
    settings_description:
      'Usamos cookies y tecnologías similares para ofrecer esta experiencia. Las cookies estrictamente necesarias siempre están activas.',
    save_error: 'No se pudo guardar tu elección de privacidad. Inténtalo de nuevo.'
  },
  categories: {
    strictly_necessary: {
      name: 'Estrictamente necesarias',
      purpose: 'Necesarias para ofrecer esta experiencia y no se pueden desactivar.'
    },
    analytics: {
      name: 'Analítica',
      purpose: 'Mide cómo usan los visitantes esta experiencia para mejorar el rendimiento.'
    },
    marketing: { name: 'Marketing', purpose: 'Admite la publicidad y el marketing elegidos por el organizador.' }
  }
};

export default locale;
